import {
  EHideOfferActionTypes,
  IHideOfferSuccessPayload,
  TFailureHideOffer,
  TRequestHideOffer,
  TSuccessHideOffer,
} from './types';
import {
  EDealType as EOfferDealType,
  EOfferType as EOfferOfferType,
  IDailyRentOfferForMobileSite,
} from '../../repositories/dailyrent/entities/daily_rent_offers_for_web/DailyRentOfferForMobileSite';
import {
  EDealType as EHideDealType,
  EOfferType as EHideOfferType,
  IHideOfferRequestSchema,
} from '../../repositories/hidden-objects/entities/offer_hiding/HideOfferRequestSchema';
import { fetchHideOffer } from '../../services/hiddenObjects';
import { TThunkAction } from '../../types/redux';
import { actionGenerator } from '../../utils/redux/actionGenerator';

const requestHideOffer: () => TRequestHideOffer = actionGenerator<EHideOfferActionTypes.Request>(
  EHideOfferActionTypes.Request,
);
const successHideOffer: (payload: IHideOfferSuccessPayload) => TSuccessHideOffer = actionGenerator<
  EHideOfferActionTypes.Success,
  IHideOfferSuccessPayload
>(EHideOfferActionTypes.Success);
const failureHideOffer: () => TFailureHideOffer = actionGenerator<EHideOfferActionTypes.Failure>(
  EHideOfferActionTypes.Failure,
);

// Значения enum совпадают, но типы номинально разные (две сгенерированные схемы)
// маппим явно через Record, чтобы добавление варианта на любой стороне ловилось компилятором.
const DEAL_TYPE_MAP: Record<EOfferDealType, EHideDealType> = {
  [EOfferDealType.Rent]: EHideDealType.Rent,
  [EOfferDealType.Sale]: EHideDealType.Sale,
};
const OFFER_TYPE_MAP: Record<EOfferOfferType, EHideOfferType> = {
  [EOfferOfferType.Commercial]: EHideOfferType.Commercial,
  [EOfferOfferType.Flat]: EHideOfferType.Flat,
  [EOfferOfferType.Newobject]: EHideOfferType.Newobject,
  [EOfferOfferType.Suburban]: EHideOfferType.Suburban,
};

export function mapOfferToHideRequest(offer: IDailyRentOfferForMobileSite): IHideOfferRequestSchema {
  return {
    offerId: offer.id,
    dealType: DEAL_TYPE_MAP[offer.dealType],
    offerType: OFFER_TYPE_MAP[offer.offerType],
    publishedUserId: offer.author?.realtyId ?? 0,
  };
}

export const hideOffer =
  (offer: IDailyRentOfferForMobileSite): TThunkAction<Promise<void>> =>
  async (dispatch, _getState, context) => {
    const { logger } = context;

    try {
      dispatch(requestHideOffer());

      await fetchHideOffer(context, mapOfferToHideRequest(offer));

      dispatch(successHideOffer({ offerId: offer.id }));
    } catch (error) {
      dispatch(failureHideOffer());

      logger.error(error);
      throw error;
    }
  };
